import { createSelector } from 'reselect'
import { ReceiptAutoMatchPushTaskListResponse } from 'src/app/UploadReceiptsAutoMatchPopup/redux/uploadReceiptsAutoMatch.reducers'
import { RootState } from 'src/redux/createRootReducer'
import { selectReceiptAttachmentsListModels } from 'src/redux/selectors/data/receiptAttachments.selectors'

const selectReceiptAttachmentIdsFromState = (state: RootState): string[] =>
  state.app.receiptAutoMatch.receiptAttachmentIds

export const selectReceiptAttachmentModelsList = createSelector(
  [selectReceiptAttachmentIdsFromState, selectReceiptAttachmentsListModels],
  (ids, receiptAttachments) =>
    Object.keys(receiptAttachments).length > 0
      ? ids.map((id) => receiptAttachments[id])
      : [],
)

export const selectUploadingAttachmentsFromState = (
  state: RootState,
): Record<string, string> =>
  state.app.receiptAutoMatch.uploadingAttachmentThumbnails

export const selectReceiptsAutoMatchPushTaskListFromState = (
  state: RootState,
): ReceiptAutoMatchPushTaskListResponse[] =>
  state.app.receiptAutoMatch.receiptAutoMatchPushTaskList

export const selectReceiptsAutoMatchEnabledFromState = (
  state: RootState,
): boolean => state.app.receiptAutoMatch.enabled

export const selectReceiptsAutoMatchErrorFromState = (
  state: RootState,
): string | undefined => state.app.receiptAutoMatch.receiptsAutoMatchError

export const selectReceiptsAutoMatchIsCreatingExpensesFromState = (
  state: RootState,
): boolean | undefined => state.app.receiptAutoMatch.isCreatingExpenses
